.date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 0 calc(var(--spacing) * 2);
  font-size: 16px;
  border-radius: var(--border-radius);
  background: var(--color-cool-gray);
  border: none;
  cursor: pointer;

  & svg {
    flex-shrink: 0;
  }
}

.dateTriggerText {
  &::first-letter {
    text-transform: capitalize;
  }
}


.timeInput {
  width: 100%;
  padding: 6px 8px;
  font-size: 16px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: var(--border-radius);
  background: var(--color-cool-gray);
}

/*-------------------------------------------
// Customize the date picker
//-----------------------------------------*/

:global(.react-datepicker-time__input) {
  margin-left: 0 !important;
}

:global(.react-datepicker__triangle) {
  display: none;
}

:global(.react-datepicker__input-time-container) {
  margin-right: 15px !important;
}

:global(.react-datepicker-time__input-container) {
  width: 100% !important;
}

:global(#datepicker-portal) {
  position: relative;
  z-index: 9999;
}

:global(.react-datepicker) {
  border: none !important;
  border-radius: none !important;
  background-color: var(--color-cool-gray) !important;
}

:global(.react-datepicker__header) {
  background-color: var(--color-cool-gray) !important;
  border: none !important;
}

:global(.react-datepicker__current-month) {
  text-transform: capitalize;
}

:global(.react-datepicker__day--selected) {
  color: black !important;
  background-color: var(--color-yellow) !important;
  border-radius: 50% !important;
}

:global(.react-datepicker__day--keyboard-selected) {
  color: black !important;
  background-color: var(--color-cool-gray) !important;
  border-radius: 50% !important;
}

:global(.react-datepicker__day-name) {
  text-transform: uppercase;
}

.timeInputRow {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.timeInputRow .timeInput {
  flex: 1;
  width: auto;
}

.calendarOkButton {
  padding: 0 16px;
  background: var(--color-on-surface, #17181a);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

@media (--lg) {
  :global(.react-datepicker__day-name), :global(.react-datepicker__day), :global(.react-datepicker__time-name ) {
    width: 2rem !important;
    line-height: 2rem !important;
    margin-right: 1rem !important;
  }
  :global(.react-datepicker__current-month) {
    margin-bottom: 10px;
  }
  :global(.react-datepicker__header ) {
    margin-top: 10px;
  }
  :global(.react-datepicker__navigation  ) {
    margin-top: 10px;
  }
}